
export default function useSavedUrls () {
  const saveBackUrl = url => {
    window.sessionStorage.setItem('shopkoeb-back-url', url)
  }
  return {
    saveBackUrl
  }
}
